<template>
  <div class="search-wrapper">
    <div class="search-body">

      <div class="goodslist-body show-goods-list" >
        <!-- 无限加载滚动列表 -->
        <div class="flex-wrapper" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
          <div class="grid-item item"
               v-for='(item, index) in articleList'
               v-bind:key='index' @click="goArticleDetail(item)"
          >
            <img v-lazy="item.article_pic" class="item-img">
            <section class="section-p">
              <p class="title-p">{{ item.article_title }}</p>
            </section>
          </div>
        </div>
        <div class="loading-wrapper" v-if="articleList.length > 0">
          <p class="common-no-more" v-if='!isMore'>没有更多了</p>
          <mt-spinner type="triple-bounce" color='#e93b3d' v-if='isMore'></mt-spinner>
        </div>
        <empty-record v-if='articleList.length <= 0 && !isMore'></empty-record>
      </div>
    </div>
  </div>
</template>

<script>
  import { Toast, Indicator } from 'mint-ui'
  import { articleFound } from '../../../api/homesearch'
  export default {
    data () {
      return {
        articleList: [],
        params: { 'page': 0, 'per_page': 10 },
        loading: false, // 是否加载更多
        isMore: true // 是否有更多
      }
    },
    methods: {
      loadMore () {
        if(this.loading){
          return
        }
        this.loading = true
        this.params.page = ++this.params.page
        if (this.isMore) {
          this.articleFound(true)
        }
      },
      articleFound () {
        Indicator.open()
        articleFound(this.params).then(res => {
          Indicator.close()
          if (res.result.hasmore) {
            this.isMore = true
          } else {
            this.isMore = false
          }

          if (this.articleList) {
            this.articleList = this.articleList.concat(res.result.article_list)
          } else {
            this.articleList = res.result.article_list
          }
          this.article_type_name = res.result.article_type_name
          this.loading = false
        }).catch(error=> {
          Indicator.close()
          Toast(error.message)
          this.loading = false
        })
      },
      goArticleDetail (item) {
        if(item.article_url){
          // window.location.href = item.article_url
          this.$router.push({ 'name': 'ArticledetailWx', 'query': { 'article_id': item.article_id } })
        }else {
          this.$router.push({ 'name': 'HomeArticledetail', 'query': { 'article_id': item.article_id } })
        }
      }
    }
  }
</script>

<style lang='scss' scoped>
  .item {
    width: calc(100% - 0.4rem );
    transition: opacity .4s ease-in-out; // 检索或设置对象变换时的过渡
    display: inline-block;
    margin: 0.5rem 0;
    box-shadow: 0px 0.05rem 0.05rem rgba(34, 25, 25, 0.4);
  }
  .item-img {
    width: 100% !important;
    display:block;
  }
  .section-p {
    font-size: 0.7rem;
    margin: 0.2rem;
  }
  .flex-wrapper{
    column-count: 2; // 设置显示2列
    column-gap: 2px; //设置或检索对象的列与列之间的间隙为2px
    width: 100%;
    padding: 0.2rem;
  }
  .ui-goodslist-filter {
    width: auto;
    ul.filter-list{
      display: flex;
      width: auto;
      justify-content: space-around;
      align-content: center;
      align-items: center;
      border: 0;
      border-top: .045rem solid #E8EAED;
      border-bottom: .045rem solid #E8EAED;
      li{
        font-size: .7rem;
        color: #333;
        border-bottom: .1rem solid transparent;
        position: relative;
        flex-basis: 4.54rem;
        text-align: center;
        height: 1.9rem;
        padding: 0;
        line-height: 1.9rem;
        a {
          height: 1.9rem;
          display: inline-block;
        }
        img {
          height: .18rem;
          width: .36rem;
          vertical-align: middle;
        }
        .iconfont{display: inline-block}
      }
      li.sortactive {
        border-bottom-color:#e93b3d;
        a {
          color:$primaryColor;
        }
        .iconfont{color:#e93b3d;}
        .iconfont.active{transform: rotate(180deg);}
      }
      li.sortnormal {
        border-bottom-color: transparent;
        a {
          color: #333;
        }
      }
      .arrow-icon {
        width: .54rem;
        height: .54rem;
      }
    }
    .sort-model {
      position: absolute;
      left: 0;
      width: 100%;
      z-index: 10;
      div {
        color: #333;
        padding: .68rem;
        font-size: .59rem;
        background-color: #fff;
        margin: 0;
        border-bottom: .045rem solid #E8EAED;
        cursor: pointer;
        display: flex;
        width: auto;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        img {
          float: right;
          width: .7rem;
          height: .7rem;
        }
        &.active {
          color: $primaryColor;
        }
      }
    }
  }
</style>
